import { render } from "./CalendarTreeComponent.vue?vue&type=template&id=6af37c3a&scoped=true"
import script from "./CalendarTreeComponent.vue?vue&type=script&lang=js"
export * from "./CalendarTreeComponent.vue?vue&type=script&lang=js"

import "./CalendarTreeComponent.vue?vue&type=style&index=0&id=6af37c3a&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af37c3a"]])

export default __exports__